let pendingAuthRefresh: Promise<string> | null = null;
const AUTH_REFRESH_LOCK = 'lookbel-auth-refresh';

type LockCapableNavigator = Navigator & {
  locks?: {
    request: <T>(name: string, callback: () => Promise<T>) => Promise<T>;
  };
};

/**
 * Share a single refresh-token rotation across every concurrent caller.
 * The slot is released after success or failure so a future request can retry.
 */
export const coordinateAuthRefresh = (
  refresh: () => Promise<string>,
): Promise<string> => {
  if (!pendingAuthRefresh) {
    const locks = typeof navigator === 'undefined'
      ? undefined
      : (navigator as LockCapableNavigator).locks;

    // Web Locks serialize refresh-token rotation across browser tabs. The
    // in-memory promise remains the same-tab fast path and non-browser fallback.
    const refreshRequest = locks
      ? locks.request(AUTH_REFRESH_LOCK, refresh)
      : refresh();

    pendingAuthRefresh = refreshRequest.finally(() => {
      pendingAuthRefresh = null;
    });
  }

  return pendingAuthRefresh;
};
